import React from "react";
import BannerDetailPage from "features/MarketingBanner/presentation/pages/BannerDetail";

function BannerDetailScreen() {
  return <BannerDetailPage />;
}

export default BannerDetailScreen;
